import {Component, OnInit, Injector} from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MenuService } from '../../../core/menu/menu.service';
import {menu, menuIcons, menuRedes} from '../../menu';
import {Md5} from 'ts-md5';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})

export class LoginComponent implements OnInit {

  valForm: FormGroup;

  protected router: Router;

  errorMessage = '';
  errorFiltro = '';

  public operacao = 'manual';
  public dadosArmazenados: any = {};
  public checaFiltros = 0;

  public hash_auth = '';

  constructor(
      injector: Injector,
      public settings: SettingsService,
      public menuService: MenuService,
      private http: HttpClient,
      fb: FormBuilder
  ) {

    this.valForm = fb.group({
        'cpf': [null, Validators.required],
        'password': [null, Validators.required],
        'remember': [null]
    });

    this.router = injector.get(Router);

    this.errorMessage = '';

  }

  ngOnInit() {

   if (localStorage.getItem('AUTH')) {
      this.operacao = 'auto';
      this.dadosArmazenados = JSON.parse(localStorage.getItem('AUTH'));
      this.hash_auth = this.dadosArmazenados.hash_auth;
      this.login('');
    } else {
      this.operacao = 'manual';
    }

  }

  voltarLogin() {
    localStorage.clear();
    this.operacao = 'manual';
  }

  primeiroAcesso() {
    this.router.navigate(['/primeiro-acesso']);
  }

  submitForm($ev, value: any) {

    // console.log('>>>>>>>>>> iniciando login...');

    $ev.preventDefault();

    for (const c in this.valForm.controls) {
        this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.login(value);
    }
  }

  login(value: any) {

    const credenciais: any = {};
    const auth: any = {};

    credenciais.versao = '2023.09.18';

    if (this.operacao === 'manual') {
      credenciais.operacao = 'manual';
      auth.cpf = value.cpf;
      auth.senha = Md5.hashStr(value.password);
      auth.hash = value.cpf + Md5.hashStr(value.password);
    } else if (this.operacao === 'auto') {
      credenciais.operacao = 'auto';
      auth.cpf = this.dadosArmazenados.cpf;
      auth.senha = this.dadosArmazenados.senha;
      auth.hash = this.dadosArmazenados.cpf + this.dadosArmazenados.senha;
    }

    const config = {
      headers: {
        'x-token': this.settings.configUso.X_TOKEN_API,
        'hash_auth': this.hash_auth,
        'auth': auth.hash
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'proxy/hotsite/v1/usuario/login';

    this.http.post(url, credenciais, config)
      .subscribe(data => {

          // console.log('>>>>> Result:' + JSON.stringify(data));
          if (data['status'] === 200) {

            /********************************/
            /***** SE NÃO RETORNA DADOS *****/
            /********************************/

            if (!data['result']) {
              return this.errorMessage = data['message'];
            }

            /*************************/
            /***** DEFINE ACESSO *****/
            /*************************/

            if (
              data['result'].idperfil !== 1
              // && data['result'].idperfil !== 2
              // && data['result'].idperfil !== 3
              // && data['result'].idperfil !== 4
              // && data['result'].idperfil !== 6
              // && data['result'].idperfil !== 12
              // && data['result'].idperfil !== 13
            ) {
              this.operacao = 'manual';
              return this.errorMessage = 'Acesso Negado!';
            }

            this.settings.logado = true;
            this.settings.user = data['result'];
            this.settings.user.cpf = auth.cpf;
            this.settings.user.senha = auth.senha;
            this.settings.user.hash = auth.hash;

            /********************************/
            /***** DEFINE MANTER LOGADO *****/
            /********************************/

            if (value.remember || this.operacao === 'auto') {
              localStorage.setItem('AUTH', JSON.stringify(this.settings.user));
            } else {
              localStorage.clear();
              this.errorMessage = '';
            }

            /***************************/
            /***** CARREGA FILTROS *****/
            /***************************/

            this.carregaFiltros();

          } else {
            this.voltarLogin();
            this.errorMessage = data['message'];
          }
        },
        (error: HttpErrorResponse) => {
          this.voltarLogin();
          this.errorMessage = error.message;
        });

  }

  carregaFiltros() {

    this.operacao = 'setup';
    this.errorFiltro = '';
    this.checaFiltros = 0;

    // console.log('Carregando Filtros...');

    this.listaRedesTipos();
    // this.listaSegmentos();
    // this.listaAgrupamentos();
    // this.listaPlanos();
    // this.listaLojas();
    this.listaRegionais();
    this.listaDDDs();
    this.listaUFs();
    this.listaCNs();
    // this.listaKAs();
    this.listaRedes();
    this.listaTags();

  }

  finalizaLogin() {

    if (this.checaFiltros < 6) {

      // console.log('Filtros carregados: ' + this.checaFiltros + ' / 10');

    } else {

      /***********************/
      /***** DEFINE MENU *****/
      /***********************/

      if (this.settings.user.idperfil === 1) {
        this.menuService.addMenu(menuIcons);
      } else if (this.settings.user.idperfil === 13) {
        this.menuService.addMenu(menuRedes);
      } else {
        this.menuService.addMenu(menu);
      }

      /***************************/
      /***** DEFINE REDIRECT *****/
      /***************************/

      if (!this.settings.urlretorno || this.settings.urlretorno === '') {

        if (this.settings.user.idperfil === 1) {
          this.router.navigate(['/usuarios']);
        } else if (this.settings.user.idperfil === 13) {
          this.router.navigate(['/dashboard/redes']);
        } else {
          this.router.navigate(['/dashboard/vendas']);
        }

      } else {
        this.router.navigate([this.settings.urlretorno]);
      }

    }

  }

  listaRedesTipos() {

    // console.log('listando Tipos de Redes...');

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/redes/tipos';

    this.http.get(url)

      .subscribe(data => {

        if (data['status'] === 200) {

          this.settings.filtroRedesTipos = data['result'];
          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Tipos de Redes.';

        }
      });

  }

  listaSegmentos() {

    // console.log('listando Segmentos...');

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/planos/segmentos';

    this.http.get(url)

      .subscribe(data => {

        if (data['status'] === 200) {

          this.settings.filtroSegmentos = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Segmentos.';

        }
      });

  }

  listaAgrupamentos() {

    // console.log('listando Agrupamentos...');

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/planos/agrupamentos';

    this.http.get(url)

      .subscribe(data => {

        if (data['status'] === 200) {

          this.settings.filtroAgrupamentos = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Agrupamentos.';

        }
      });

  }

  listaPlanos() {

    // console.log('listando Planos...');

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/planos/planos';

    this.http.get(url)

      .subscribe(data =>
      {
        if (data['status'] === 200) {

          this.settings.filtroPlanos = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Planos.';

        }
      });

  }

  listaLojas() {

    // console.log('listando Lojas...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/lojas';

    this.http.get(url, config)

      .subscribe(data =>
      {
        if (data['status'] === 200) {

          this.settings.filtroLojas = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Lojas.';

        }
      });

  }

  listaRegionais() {

    // console.log('listando Regionais...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/regionais';

    this.http.get(url, config)

      .subscribe(data =>
      {
        if (data['status'] === 200) {

          this.settings.filtroRegionais = data['result'];
          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Regionais.';

        }
      });

  }

  listaDDDs() {

    // console.log('listando DDDs...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/ddds';

    this.http.get(url, config)

        .subscribe(data =>
        {
          if (data['status'] === 200) {

            this.settings.filtroDDDs = data['result'];
            this.checaFiltros ++;
            this.finalizaLogin();

          } else {

            this.errorFiltro = 'Erro ao carregar filtro de DDDs.';

          }
        });

  }

  listaUFs() {

    // console.log('listando UFs...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/ufs';

    this.http.get(url, config)

      .subscribe(data =>
      {
        if (data['status'] === 200) {

          this.settings.filtroUFs = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de UFs.';

        }
      });

  }

  listaCNs() {

    // console.log('listando CNs...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/cn';

    this.http.get(url, config)

      .subscribe(data =>
      {
        if (data['status'] === 200) {

          this.settings.filtroCNs = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de CNs.';

        }

      });

  }

  listaKAs() {

    // console.log('listando CNs...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/key';

    this.http.get(url, config)

        .subscribe(data =>
        {
          if (data['status'] === 200) {

            this.settings.filtroKAs = data['result'];

            this.checaFiltros ++;
            this.finalizaLogin();

          } else {

            this.errorFiltro = 'Erro ao carregar filtro de Key Accounts.';

          }

        });

  }

  listaRedes() {

    // console.log('listando Redes...');

    const config = {
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/redes';

    this.http.get(url, config)

      .subscribe(data =>
      {
        if (data['status'] === 200) {

          this.settings.filtroRedes = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Redes.';

        }
      });

  }

  listaTags() {

    const url = this.settings.configUso.urlApiPadrao + 'proxy/hotsite/v1/usuario/tags';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'InvalidateCache': 'true',
      'Cache-Control': 'no-cache'
    })

    this.http.get(url, { headers })
        .subscribe(data =>
        {
          if (data['status'] === 200) {

            this.settings.listaTags = data['result'];

            this.checaFiltros ++;
            this.finalizaLogin();

          } else {

            this.errorFiltro = 'Erro ao carregar filtro de Redes.';

          }
        });

  }

}
